export {
  isTestkitExists,
  isUniTestkitExists,
} from '@wix/wix-ui-test-utils/vanilla';
